import React, { createContext, useContext, useState, useCallback } from 'react';

const ValueVisibilityContext = createContext({});

export function ValueVisibilityProvider({ children }) {
    // Estado inicial: valores visíveis se não tem proteção
    const [showValues, setShowValues] = useState(() => {
        const hasProtection = localStorage.getItem('pin_protection') === 'true';
        return !hasProtection; // true se não tem proteção, false se tem
    });

    const [pinModalOpen, setPinModalOpen] = useState(false);

    // Função para lidar com alteração na proteção
    const handleProtectionChange = useCallback((isProtected) => {
        if (isProtected) {
            setShowValues(false); // Esconde valores quando ativa proteção
        } else {
            setShowValues(true); // Mostra valores quando desativa proteção
        }
    }, []);

    // Toggle de visibilidade
    const toggleValues = useCallback(() => {
        const hasProtection = localStorage.getItem('pin_protection') === 'true';
        
        if (hasProtection) {
            if (showValues) {
                // Se está mostrando, pode esconder direto
                setShowValues(false);
            } else {
                // Se está escondido e tem proteção, precisa do PIN
                setPinModalOpen(true);
            }
        } else {
            // Se não tem proteção, apenas alterna
            setShowValues(prev => !prev);
        }
    }, [showValues]);

    const handlePinSuccess = useCallback(() => {
        setPinModalOpen(false);
        setShowValues(true);
    }, []);

    const handlePinCancel = useCallback(() => {
        setPinModalOpen(false);
    }, []);

    return (
        <ValueVisibilityContext.Provider value={{
            showValues,
            setShowValues,
            toggleValues,
            pinModalOpen,
            setPinModalOpen,
            handlePinSuccess,
            handlePinCancel,
            handleProtectionChange
        }}>
            {children}
        </ValueVisibilityContext.Provider>
    );
}

export function useValueVisibility() {
    const context = useContext(ValueVisibilityContext);
    if (!context) {
        throw new Error('useValueVisibility must be used within a ValueVisibilityProvider');
    }
    return context;
}